<app-header></app-header>
<app-left-nav></app-left-nav>
<div role="main" class="main-container p-3">
  <div id="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer></app-footer>
